import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _TOASTER_MESSAGE;
export var API_CALL_STATUS = {
  FETCHING: 'fetching',
  SUCCESS: 'success',
  FAILED: 'failed'
};
export var TOASTER_MESSAGE = (_TOASTER_MESSAGE = {}, _defineProperty(_TOASTER_MESSAGE, API_CALL_STATUS.SUCCESS, __('Media Updated Successfully')), _defineProperty(_TOASTER_MESSAGE, API_CALL_STATUS.FAILED, __('Media Update Failed')), _TOASTER_MESSAGE);
export var VIEW_TYPE = {
  THUMBNAIL: 'thumbnail',
  LIST: 'list'
};